import React from 'react';
import { styles } from './CollectionHeader.css';

export type CollectionHeaderProps = {
  heading: string;
  subText?: string;
  navigation?: React.ReactElement;
};

export const CollectionHeader = ({ heading, subText, navigation }: CollectionHeaderProps) => {
  return (
    <>
      <h1 className={styles.heading}>{heading}</h1>
      <p className={styles.subText}>{subText}</p>
      {navigation ? <div className={styles.navigation}>{navigation}</div> : null}
    </>
  );
};
